"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Simple enumeration
 *
 * Copyright (C) 2019A Noom, Inc.
 * @author hubert
*/
var _default = function _default(enumeration) {
  return (0, _lodash["default"])( // If we received an array, use it directly. Otherwise only look at the object keys.
  _lodash["default"].isArray(enumeration) ? enumeration : _lodash["default"].keys(enumeration)).map(function (x) {
    return [x, x];
  }).fromPairs().value();
};

exports["default"] = _default;